import _styled from "@emotion/styled-base";
var _excluded = ["children", "loading", "inputValue", "isOpen", "onMenuPlacementChange", "getMenuProps"],
    _excluded2 = ["ref"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import { css } from "@emotion/core";
import "downshift";
import * as React from "react";
import { Popper } from "react-popper";
import { emRhythm } from "../css";
import { composeRefs } from "../utils";
import ComboboxMessage from "./ComboboxMessage";
import { jsx as ___EmotionJSX } from "@emotion/core";
var _ref = {
  name: "le00j-is-open",
  styles: "label:is-open;opacity:1;transform:scaleY(1);transition-duration:250ms;pointer-events:auto;"
};

var StyledComboboxMenu = /*#__PURE__*/_styled("div", {
  target: "epwboux0"
})(function (_ref2) {
  var theme = _ref2.theme;
  return /*#__PURE__*/css("label:base;width:100%;max-height:", emRhythm(12), ";margin-top:-1px;box-sizing:border-box;color:", theme.colors.heading, ";background:white;border:1px solid ", theme.colors.rule, ";border-radius:0 0 ", theme.radii.md, " ", theme.radii.md, ";box-shadow:", theme.elevations[10], ";overflow-x:hidden;overflow-y:auto;z-index:2;opacity:0;transform:scaleY(0);transform-origin:0 0;transition:all 0 ease-out;pointer-events:none;");
}, function (_ref3) {
  var isOpen = _ref3.isOpen;
  return isOpen && _ref;
}, function (_ref4) {
  var placement = _ref4.placement,
      theme = _ref4.theme;
  return placement && placement.indexOf("top") === 0 && /*#__PURE__*/css("label:is-open-top;border-radius:", theme.radii.md, " ", theme.radii.md, " 0 0;transform-origin:0 100%;");
});

var ComboboxMenu = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ComboboxMenu, _React$Component);

  function ComboboxMenu() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ComboboxMenu.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        loading = _this$props.loading,
        inputValue = _this$props.inputValue,
        isOpen = _this$props.isOpen,
        onMenuPlacementChange = _this$props.onMenuPlacementChange,
        getMenuProps = _this$props.getMenuProps,
        props = _objectWithoutPropertiesLoose(_this$props, _excluded);

    var content = children;

    if (loading) {
      content = ___EmotionJSX(ComboboxMessage, null, "Loading\u2026");
    } else if (React.Children.toArray(children).length === 0) {
      content = ___EmotionJSX(ComboboxMessage, null, inputValue === "" ? "No results" : "No results for \"" + inputValue + "\"");
    }

    return ___EmotionJSX(Popper, {
      placement: "bottom-start",
      modifiers: {
        computeStyle: {
          gpuAcceleration: false
        }
      }
    }, function (popperProps) {
      onMenuPlacementChange(popperProps.placement);

      var _getMenuProps = getMenuProps(),
          menuPropsRef = _getMenuProps.ref,
          menuProps = _objectWithoutPropertiesLoose(_getMenuProps, _excluded2);

      return ___EmotionJSX(StyledComboboxMenu, _extends({
        ref: composeRefs([popperProps.ref, menuPropsRef]),
        style: popperProps.style,
        isOpen: isOpen,
        placement: popperProps.placement
      }, menuProps, props), content);
    });
  };

  return ComboboxMenu;
}(React.Component);

ComboboxMenu.defaultProps = {
  loading: false,
  isOpen: false
};
export { ComboboxMenu as default };